import { SetPropertyActionValue } from './types'

export abstract class PropertyValue {
  type!: SetPropertyActionValue | null
}

export class PropValueProperty extends PropertyValue {
  declare type: SetPropertyActionValue.Property
  property_index!: number | null
  transform!: any
}

export class PropValueCalculate extends PropertyValue {
  declare type: SetPropertyActionValue.Calculate
  value!: string
}

export class PropValueConstant extends PropertyValue {
  declare type: SetPropertyActionValue.Constant
  value!: string | number | boolean
}

export class PropValueNow extends PropertyValue {
  declare type: SetPropertyActionValue.Now
}
